export default __webpack_public_path__ + "static/media/lizenz.14a97a87.png";